import Button from '../Button/index';
import { RxCross1 } from 'react-icons/rx';
import PropTypes from 'prop-types';
import Heading from '../Heading';


const Modal = ({ isOpen, onClose, onDelete, children, showCal, isAccess, message }) => {
    if (!isOpen && !showCal) {
        return null;
    } if (showCal && !isOpen) {
        return (
            <>
                <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-opacity-75 z-999 ">
                    <div className="w-full max-w-md p-6 rounded  box-shodow relative bg-white">
                        <span className="float-right cursor-pointer text-gray-600 text-2xl absolute cross" onClick={onClose}>&times;</span>
                        {children}
                    </div>
                </div>
            </>
        )
    } else {
        return (
            <>
                <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-opacity-75 z-999  custome-modal-box">
                    <div className="w-full max-w-md p-6 rounded  relative bg-white box-shodow ">
                        <span className="float-right cursor-pointer text-gray-600 text-2xl absolute cross" onClick={onClose}>&times;</span>
                        {!message && <div>
                        <h2 className="text-xl mb-4 text-center">Confirmation</h2>
                        <p className="mb-6">Are you sure you want to delete this {isAccess ? 'access' : 'timelog entry'}?</p>
                       
                        <div className="flex justify-end">
                            <button onClick={onDelete} className="px-4 py-2 bg-red-500 text-white  bg-yellow  rounded mr-2">Yes</button>
                            <button onClick={onClose} className="px-4 py-2 bg-blue  text-white   bg-gray-300 rounded">No</button>
                        </div>
                        </div>}
                       {message && 
                       <div>
                         <p className="mb-6 text-center margin-bottom-custom">
                            <p className='text-red text-xl font-extrabold mb-2 custome-box-modal'>Heads Up! </p>
                            <p className='text-xl font-medium mb-2' > {message}</p>
                            
                            </p>
                        </div>}
                    </div>
                </div>
            </>
        );
    }
};

export default Modal;
